import React from "react";
import "./Contact.css";
import "../../components/atoms/PrimaryBtn/PrimaryBtn.css";
import "../shared/Shared.css";
import { motion } from "framer-motion";
import {
  FaHandshake,
  FaRocket
} from "react-icons/fa";
import { headingAnimation } from "../../hooks/useAnimation";
import { BottomLine } from "../../components";

const Contact = () => {
  const viewDiv = true;

  return (
    <div className="relative py-20 px-6 sm:px-10 lg:px-16 bg-[#0c0a16] text-white overflow-hidden">

      {/* Static gradient lights */}
      <div className="absolute top-0 left-0 w-72 h-72 bg-gradient-to-r from-violet-700 to-indigo-700 blur-[120px] opacity-[0.12] pointer-events-none" />
      <div className="absolute bottom-0 right-0 w-72 h-72 bg-gradient-to-r from-indigo-700 to-violet-700 blur-[120px] opacity-[0.12] pointer-events-none" />

      {/* Heading */}
      <motion.div
        initial="hidden"
        animate={viewDiv && "visible"}
        variants={headingAnimation}
        className="relative z-10 text-center mb-12"
      >
        <h1 className="text-3xl sm:text-4xl font-semibold mb-3">
          Get In{" "}
          <span className="bg-gradient-to-r from-violet-400 to-indigo-400 bg-clip-text text-transparent">
            Touch
          </span>
        </h1>
        <h3 className="text-gray-400 text-sm sm:text-base tracking-wide">
          Feel Free To Contact Me
        </h3>
        <BottomLine />
      </motion.div>

      {/* Why Choose Me Section */}
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={viewDiv ? { opacity: 1, y: 0 } : {}}
        transition={{ delay: 0.8 }}
        className="mt-10 relative z-10"
      >
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-3 px-6 py-4 rounded-2xl bg-gradient-to-r from-violet-900/30 to-indigo-900/30
                          border border-violet-500/20 backdrop-blur-sm mb-8">
            <FaHandshake className="text-2xl text-violet-300" />
            <div>
              <h3 className="text-xl font-bold text-white mb-1">
                Transparent Collaboration
              </h3>
              <p className="text-gray-300 text-sm">
                Regular updates, clear communication, and collaboration.
              </p>
            </div>
          </div>

          <p className="text-gray-400 mb-8 max-w-3xl mx-auto leading-relaxed">
            I measure my success by how satisfied my clients are with the final outcome.
            I take the time to deeply understand your goals, deliver real value, and build
            solutions that genuinely help your business grow. When you&apos;re satisfied, that&apos;s
            when I consider the project a true success.
          </p>

          <a
            href="https://mail.google.com/mail/?view=cm&fs=1&to=maliksimra033@gmail.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="bg-gradient-to-r from-violet-600 to-indigo-600 px-8 py-3 rounded-full font-medium inline-flex items-center gap-2"
            >
              Let's Work Together
              <FaRocket />
            </motion.button>
          </a>

        </div>
      </motion.div>

    </div>
  );
};

export default Contact;
